<template>
  <div class="SELECT_DATE">
    <DatePicker 
      :value="valuedata"
      format="yyyy-MM-dd"
      type="date"
      transfer
      :placeholder="t('请选择查询时间')"
      @on-change="handleChange"
    />
  </div>
</template>

<script>

export default {
  name: 'SELECT_DATE',
  data() {
    return {
      valuedata: '',
    };
  },
  methods: {
    handleChange(date) {
      this.valuedata = date
    }
  }
};

</script>
